<template>
  <div>
    <div v-if="chipType">
      <v-chip style="margin: 2px" small v-for="item in items" :key="item.id">{{
        getChipItemTitle(item)
      }}</v-chip>
    </div>
    <div v-if="!chipType">
      <span v-for="(item, index) in items" :key="item.id">{{
        getItemTitle(item, index)
      }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ElTableArrayItem',
  props: {
    items: Array,
    chipType: { type: Boolean, default: false },
  },
  computed: {},
  methods: {
    getChipItemTitle(item) {
      if (item) {
        return this.$i18n.locale === 'lt' ? item.title_lt : item.title_en
      } else {
        return ''
      }
    },
    getItemTitle(item, index) {
      if (item) {
        let length = this.items.length
        let title = this.$i18n.locale === 'lt' ? item.title_lt : item.title_en
        if (length > 1 && length != index + 1) {
          title += ', '
        }
        return title
      } else {
        return ''
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
